"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        color: 'inherit',
        position: 'relative',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: theme.grey7,
        borderRadius: '50%',
        overflow: 'hidden',
        boxSizing: 'border-box',
        display: 'block',
        boxShadow: `0 0 0 0 ${theme.indigoPastel2}`,
        transition: `box-shadow 150ms linear 0ms, border-color 100ms linear 0ms`,
        '&[data-has-border=true]': {
            borderWidth: 1
        }
    },
    ratioImage: {
        display: 'block',
        width: '100%',
        height: 'auto'
    }
});
//# sourceMappingURL=avatar.style.js.map